__turbopack_context__.v({
  "blockquote": "RichText-module-scss-module__4G0fQG__blockquote",
  "bold": "RichText-module-scss-module__4G0fQG__bold",
  "heading": "RichText-module-scss-module__4G0fQG__heading",
  "italic": "RichText-module-scss-module__4G0fQG__italic",
  "listItem": "RichText-module-scss-module__4G0fQG__listItem",
  "orderedList": "RichText-module-scss-module__4G0fQG__orderedList",
  "paragraph": "RichText-module-scss-module__4G0fQG__paragraph",
  "table": "RichText-module-scss-module__4G0fQG__table",
  "underline": "RichText-module-scss-module__4G0fQG__underline",
  "unorderedList": "RichText-module-scss-module__4G0fQG__unorderedList",
});
